import type { ActiveGameData } from '@ps/web-poker-types';
import type React from 'react';

import GameItem from './GameItem';
import styles from './GamesList.module.scss';

interface Props {
  games: ActiveGameData[];
}

const GamesList: React.FC<Props> = ({ games }) => (
  <div className={styles.gamesList}>
    {games.map((game) => (
      <GameItem key={game.id} game={game} />
    ))}
  </div>
);

export default GamesList;
